/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesProfileUpdateProfileSettingsRequest interface.
 */
export function instanceOfFxIdWebFeaturesProfileUpdateProfileSettingsRequest(value) {
    if (!('DUMMY' in value) || value['DUMMY'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesProfileUpdateProfileSettingsRequestFromJSON(json) {
    return FxIdWebFeaturesProfileUpdateProfileSettingsRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileUpdateProfileSettingsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'DUMMY': json['__DUMMY'],
        'MarketingEnabled': json['MarketingEnabled'] == null ? undefined : json['MarketingEnabled'],
        'Language': json['Language'] == null ? undefined : json['Language'],
    };
}
export function FxIdWebFeaturesProfileUpdateProfileSettingsRequestToJSON(json) {
    return FxIdWebFeaturesProfileUpdateProfileSettingsRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileUpdateProfileSettingsRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        '__DUMMY': value['DUMMY'],
        'MarketingEnabled': value['MarketingEnabled'],
        'Language': value['Language'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesProfileUpdateProfileSettingsRequest.js.map